<ngx-spinner type="square-jelly-box">
  <h3>Loading...</h3>
</ngx-spinner>

@if (themeReady) {
  <div class="redirect-wrap">
    <div class="redirect-copy">Preparing your offer...</div>
  </div>
}
